import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RemoteConfigService } from 'src/app/core/services/remote-config.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {
  maintenanceMessage: string | null = null;

  constructor(private remoteConfigService: RemoteConfigService, private router: Router) {}

  async ngOnInit() {
    const isMaintenance = await this.remoteConfigService.getMaintenanceAdmin();
    if (!isMaintenance) {
      this.router.navigate(['/login']);
    }
    try {
      const msg = await this.remoteConfigService.getMaintenanceMessage();
      this.maintenanceMessage = msg;
    } catch {
      this.maintenanceMessage = null;
    }
  }
} 